import { AdminTableHeadProps } from './admin-table-head-props';
import React from 'react';
import { TableHead } from '@mint/ui';

export const AdminTableHead: React.FunctionComponent<
  AdminTableHeadProps
> = TableHead;
